import { render } from "./AgreementsManag.vue?vue&type=template&id=53f7301e&scoped=true"
import script from "./AgreementsManag.vue?vue&type=script&lang=js"
export * from "./AgreementsManag.vue?vue&type=script&lang=js"

import "./AgreementsManag.vue?vue&type=style&index=0&id=53f7301e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f7301e"]])

export default __exports__